<template>
    <b-card no-body>
        <b-card-header>
            <div class="h5 mb-0">
                Gestão do Boletim de Medição
                <div class="float-right">
                    <button
                        class="btn btn-danger"
                        @click.stop="voltar()"
                    >
                        <i class="fa fa-arrow-left mr-2"></i>Voltar
                    </button>
                </div>
            </div>
        </b-card-header>

        <b-tabs pills card vertical v-model="tabIndex">
            <b-tab v-if="podeVerParametros" title="Parâmetros do Boletim">
                <parametros-boletins-conteudo />
            </b-tab>

            <b-tab title="Histórico de BMs Excluídos">
                <historico-exclusoes-boletins :contrato="contrato" />
            </b-tab>

            <b-tab title="Histórico de Aditivos">
                <historico-aditivos :contrato="contrato" />
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import ParametrosBoletinsConteudo from './ParametrosBoletinsConteudo.vue';
import HistoricoExclusoesBoletins from './HistoricoExclusoesBoletins.vue';
import HistoricoAditivos from './HistoricoAditivos.vue';

export default {
    components: {
        ParametrosBoletinsConteudo,
        HistoricoExclusoesBoletins,
        HistoricoAditivos
    },

    props: {
        contrato: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            tabIndex: 0
        }
    },

    computed: {
        podeVerParametros() {
            return !!(
                this.contrato &&
                (this.contrato.usuarioEhGestorContratos || this.contrato.usuarioEhOrdenador)
            )
        }
    },

    methods: {
        voltar() {
            this.$router.push({
                name: 'FornecedorContratos_BoletinsMedicoes',
                params: { codContrato: this.$route.params.codContrato }
            })
        }
    }
}
</script>
